import { systemApi } from "@/data"
import { RobotSystem } from "@/interfaces"
import { UserCredentials } from "hcosmos-api-data"

export async function resetPassword(
  id: string,
  options?: {
    username?: boolean
    email?: boolean
    passwort?: boolean
  }
): Promise<UserCredentials> {
  try {
    const creds = await systemApi.resetPassword({
      id,
      ...(options?.username !== undefined && { username: options.username }),
      ...(options?.email !== undefined && { email: options.email }),
      ...(options?.passwort !== undefined && { passwort: options.passwort }),
    })

    return creds
  } catch (e: unknown) {
    const err = e as Response
    throw (
      'Senden fehlgeschlagen: Passwort konnte nicht zurückgesetzt werden: ' +
      err.status +
      ' ' +
      err.statusText
    )
  }
}